import { useLocation, useNavigate } from 'react-router-dom';

import { Button, Heading1, InpockView, Paragraph1 } from 'inpock-ui-react';
import { colors } from 'inpock-ui-react/dist/src/color';
import queryString from 'query-string';

import { BACKUP_CHECKOUT_INFO, CHECKOUT_VERSION } from '@/constants';
import { useToast } from '@/hooks';

import * as S from './styled';

export function PayFailPage() {
  const toastOn = useToast();
  const { search } = useLocation();
  const query = queryString.parse(search);
  const navigate = useNavigate();
  const version = sessionStorage.getItem(CHECKOUT_VERSION);

  const onClickRetryBuy = () => {
    const checkoutUrl = version ? `/checkout?version=${version}` : `/checkout`;
    navigate(checkoutUrl, {
      replace: true,
    });
  };

  const onClickPrevPage = () => {
    const backupCheckoutInfo = sessionStorage.getItem(BACKUP_CHECKOUT_INFO);
    if (backupCheckoutInfo) {
      navigate(version ? `/checkout?version=${version}` : `/checkout`, {
        state: JSON.parse(backupCheckoutInfo),
      });
      sessionStorage.removeItem(BACKUP_CHECKOUT_INFO);
    } else {
      toastOn('상품 정보를 불러올 수 없어 구매자 메뉴로 이동할게요', 2000);
      navigate('/customer/menu');
    }
  };

  return (
    <InpockView>
      <div className="container">
        <S.CenterBox>
          <S.FailIcon />
          <Heading1 style={{ marginBottom: '8px' }}>구매 실패</Heading1>
          <Paragraph1
            color="gray700"
            fontWeight="regular"
            style={{ marginBottom: '12px', textAlign: 'center' }}
          >
            {query.message}
            <br />
            구매 페이지에서 다시 시도 해주세요.
          </Paragraph1>
          <S.ReasonBox>
            <Paragraph1 style={{ fontWeight: 400, color: colors.orange800 }}>
              {query.fail_reason}
            </Paragraph1>
          </S.ReasonBox>
          <S.FailButtonContainer>
            {query.campaign_id && (
              <Button size="large" type="primary" fullWidth onClick={onClickRetryBuy}>
                다시 구매
              </Button>
            )}
            {query.username && (
              <Button
                size="large"
                type="danger"
                fullWidth
                onClick={() =>
                  navigate(`/${query?.username}`, {
                    replace: true,
                  })
                }
              >
                {query.username} 마켓 홈으로 이동
              </Button>
            )}
            {!query.username && (
              <Button size="large" type="danger" fullWidth onClick={() => onClickPrevPage()}>
                이전 페이지로 이동
              </Button>
            )}
          </S.FailButtonContainer>
        </S.CenterBox>
      </div>
    </InpockView>
  );
}
